<div
  #container
  class="relative flex w-full min-w-0 flex-wrap items-center gap-1 py-1.5"
  [class.max-h-8]="!expanded()"
  [class.overflow-hidden]="!expanded()"
  *transloco="let t"
>
  <!-- TODOS os chips ficam no DOM sempre, na ordem original. Quem não cabe é empurrado para a
       segunda linha pelo `flex-wrap` e some no `max-h-8` (uma linha: 20px do chip + `py-1.5`) — é
       isso que mantém a medida honesta: chip escondido com `hidden` mede zero e faz a conta oscilar. -->
  @for (tag of visibleTags(); track $index) {
    <span
      #chip
      class="inline-flex shrink-0 items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700 whitespace-nowrap dark:bg-gray-700 dark:text-gray-200"
    >
      {{ label(tag) | capitalize }}
    </span>
  }

  <!-- O botão fica no fluxo, logo depois do último chip que coube — não encostado na borda da
       coluna. Ele entra na conta de quebra como qualquer chip: se sobrar na segunda linha, a
       contagem recolhe mais um chip para abrir espaço. -->
  @if (showToggle()) {
    <button
      #toggleButton
      type="button"
      class="inline-flex shrink-0 cursor-pointer items-center rounded-full px-2.5 py-0.5 text-xs font-semibold text-primary whitespace-nowrap hover:bg-gray-100 dark:hover:bg-gray-700"
      (click)="toggleExpanded($event)"
    >
      @if (expanded()) {
        {{ t('show-less') }}
      } @else {
        +{{ hiddenCount() }} {{ t('show-more') }}
      }
    </button>
  }

  @for (tag of hiddenTags(); track $index) {
    <span
      #chip
      class="inline-flex shrink-0 items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700 whitespace-nowrap dark:bg-gray-700 dark:text-gray-200"
    >
      {{ label(tag) | capitalize }}
    </span>
  }
</div>
